
import { translateActions } from './translate-slice';



export const initTexts = () => {
    return async (dispath) => {
        try {
            let lang = localStorage.getItem("LANG");
            if (!lang) {
                lang = "he";
                localStorage.setItem("LANG", lang)
            }
            let direction = 'rtl';
            if( lang !== 'he' && lang !== 'ar'){
                direction = 'ltr'
            }
            // to do
            // let res = await fetch('new translate service with lang and gender ')
            // return url of json
            // fetch to url
            // get gender from api to do
            let res = await fetch(window.config.translationFile.replace('lang', lang))
            let data = await res.json();
            dispath(translateActions.init({ texts: data, lang: lang, direction: direction }))
        }
        catch {

        }
    }
}